import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';

import * as TypeAHeadActions from './type-ahead.actions';

import { TypeAHeadService } from './type-a-head.service';
import { map, withLatestFrom } from 'rxjs/operators';
import { TypeaHeadState } from './type-ahead.reducer';
import { FormularyEntity, ServiceError } from '../formulary/formulary.models';
import { Store } from '@ngrx/store';

@Injectable()
export class TypeAHeadEffects {
  loadTypeaHead$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TypeAHeadActions.loadTypeAHead),
      withLatestFrom(this._store$),
      fetch<
        [TypeaHeadState],
        ReturnType<typeof TypeAHeadActions.loadTypeAHead>
      >({
        run: (action: ReturnType<typeof TypeAHeadActions.loadTypeAHead>) =>
          this._typeAHeadService
            .getTypeaHead(action.formularyRequest, action.isPublic)
            .pipe(
              map((formulary: FormularyEntity) =>
                TypeAHeadActions.loadTypeAHeadSuccess({
                  formulary,
                }),
              ),
            ),
        onError: (_, error: ServiceError) =>
          TypeAHeadActions.loadTypeAHeadFailure({ error }),
      }),
    ),
  );

  constructor(
    private _typeAHeadService: TypeAHeadService,
    private _store$: Store<TypeaHeadState>,
    private _actions$: Actions,
  ) {}
}
